/**
 view-manager
 Created by RuSsCiTy on 07.05.2018

 This manager cares on which views have to be shown / hidden / created / removed
 **/
import { PAGES } from "../const/constants";
import LoadingView from "../views/loading/loading-view";
import PreferenceBtnView from "../views/preferences-button/preferences-button-view";
import BottomInfoPanel from "../views/bottom-info-panel/bottom-info-panel";
import MainView from "../views/main/main-view";
import IntroPage from "../views/pages/intro/intro";
import AcceptCookiePage from "../views/pages/accept-cookie/accept-cookie";
import DetailsPage from "../views/pages/details/details";
import { mainChannel, viewChannel } from "../init/message-hub";
import { api } from "./api-manager";

export default class ViewManager {
  constructor({
    preferencesButton = false,
    preferencesButtonOnNotComplete = false,
    preferencesButtonPosition = "bottom right"
  } = {}) {
    this.createMainView();
    this.loadingOverlay = new LoadingView($(".loading-overlay"));
    if (preferencesButton) {
      this.preferenceButton = new PreferenceBtnView(
        $(".cookie-manager-button"),
        preferencesButtonPosition
      );
      this.preferencesButtonOnNotComplete = preferencesButtonOnNotComplete;
    }
    this.bottomInfoPanel = new BottomInfoPanel($(".bottom-info-panel"));
    this.initEvents();
  }

  createMainView() {
    $(document.body).append(
      `<div class='cookie-manager-main-container'><div class='loading-overlay'></div><div class='cookie-manager-modal'></div><div class='cookie-manager-button'></div><div class='bottom-info-panel'></div></div>`
    );
    this.modalContainer = $(".cookie-manager-modal");
    this.mainView = new MainView();
    this.modalContainer.html(this.mainView.$el);
    this.mainView.reset();
  }

  /**
   * This function is checking if user already logged in and/or have entered all need data before showing a certain page
   * @param page
   */
  showPage(page, options) {
    this.mainView.show();
    this.loading(true);
    this.togglePreferenceButton(false);
    // select the requested page
    switch (page) {
      case PAGES.intro:
        /** INTRO PAGE */
        if (!this.introPage) {
          this.introPage = new IntroPage();
        }
        this.mainView.showPage(this.introPage);
        this.loading(false);
        break;
      case PAGES.accept_cookie:
        /** ACCEPT COOKIE PAGE */
        if (!this.acceptCookiePage) {
          this.acceptCookiePage = new AcceptCookiePage();
        }
        this.mainView.showPage(this.acceptCookiePage, options);
        this.loading(false);
        break;
      case PAGES.details:
        /** MAIN PAGE */
        if (!this.detailsPage) {
          this.detailsPage = new DetailsPage();
        }
        this.mainView.showPage(this.detailsPage);
        this.loading(false);
        break;
    }
  }

  loading(show) {
    if (show) {
      this.loadingOverlay.show();
    } else {
      this.loadingOverlay.hide();
    }
  }

  hide() {
    this.loading(false);
    this.mainView.hide();
  }

  initEvents() {
    viewChannel.reply("showPage", this.showPage, this);
    viewChannel.reply("loading", this.loading, this);
    viewChannel.reply("hide", this.hide, this);
    api.show = () => {
      this.showPage(PAGES.intro);
    };
    api.showAcceptCookieDialog = ({ cookieId }) => {
      this.showPage(PAGES.accept_cookie, { cookieId });
    };
    viewChannel.reply(
      "togglePreferenceButton",
      this.togglePreferenceButton,
      this
    );
    viewChannel.reply(
      "toggleBottomInfo",
      show => {
        if (show) {
          this.bottomInfoPanel.show();
        } else {
          this.bottomInfoPanel.hide();
        }
      },
      this
    );
  }

  togglePreferenceButton(show) {
    if (this.preferenceButton) {
      if (show) {
        if (this.preferencesButtonOnNotComplete) {
          // show preference button only if not all cookies are accepted
          if (!mainChannel.request("areAllCookiesAccepted")) {
            this.preferenceButton.show();
          } else {
            this.preferenceButton.hide();
          }
        } else {
          this.preferenceButton.show();
        }
      } else {
        this.preferenceButton.hide();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src-cookie-manager/managers/view-manager.js